import React from 'react';
import { Button, IconSize, IconType } from 'ui-toolkit';
import '../../scss/_cost-data.scss';
import { RotateIcon } from './RotateIcon.styled';

interface ICostDataModal {
  className?: string;
  onToggle?: () => void;
  style?: React.CSSProperties;
  title?: React.ReactNode | string | null;
  children?: React.ReactNode;
}

export default class CostDataModal extends React.Component<ICostDataModal> {
  constructor(props: ICostDataModal) {
    super(props);
    this.onToggleButtonClick = this.onToggleButtonClick.bind(this);
  }

  public render() {
    const { children, className, style, title } = this.props;
    return (
      <div className={`cost-data cost-data--modal ${className || ''}`} style={style}>
        <div className="cost-data__row cost-data__aligned-row cost-data__header">
          <div className="cost-data__header-cell cost-data__header-name">
            <div>{title}</div>
            <Button intent="ghost" isInline onClick={this.onToggleButtonClick}>
              <RotateIcon type={IconType.CaretDd} isRotated={true} size={IconSize.Small} />
            </Button>
          </div>
        </div>
        <div className="cost-data__body">{children}</div>
      </div>
    );
  }

  protected onToggleButtonClick() {
    if (this.props.onToggle) {
      this.props.onToggle();
    }
  }
}
